//
import axios from 'axios'

//
import FamilyModel from '@/models/Warehouse/WhFamily'

const createFamily = async function(data) {
    try {
        let family = new FamilyModel(data)
        let response = await family.save()
        return response
    } catch (error) {
        return error.response.data
    }
}

//
const deleteFamily = async function(id) {
    //
    try {
        //
        let response = await axios.delete(
            process.env.VUE_APP_API_ROUTE + `/wh_family/${id}`
        )

        //
        return response
    } catch (error) {
        //
        //console.log( error )

        //
        return error.response.data
    }
}

const fetchFamily = async function(id) {
    try {
        let family = await FamilyModel.find(id)
        return family
    } catch (error) {
        return error.response.data
    }
}

const updateFamily = async function(id, data) {
    try {
        let family = await fetchFamily(id)
        family.family = data.family
        let response = await family.save()
        return response
    } catch (error) {
        return error.response.data
    }
}

const fetchAllFamily = async function() {
    try {
        let family = await FamilyModel.params({
            get_all_results: true,
        }).get()
        return family.data
    } catch (error) {
        return error.response.data
    }
}

export default {
    createFamily,
    deleteFamily,
    fetchFamily,
    updateFamily,
    fetchAll: fetchAllFamily,
    fetchAllFamily,
}
